module.exports = __webpack_public_path__ + "static/img/alipay.3dc7a6da.png";